import { render, staticRenderFns } from "./testbed.vue?vue&type=template&id=05135a20"
import script from "./testbed.vue?vue&type=script&lang=js"
export * from "./testbed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports